export const api = {
    auditUser: 'audit/user'
};

export const queryApi = {

};